import React from 'react';
import PropTypes from 'prop-types';
import {
  feesCard,
  feesSideSection
} from '../componentSections/detailsFeesComponents';
import { fireDetailsPageComponentFailureFpti } from '../../../lib/helpers';
import { clientLogger } from '../../../lib/logger';

const DetailsFees = ({
  componentContent = {},
  fptiImpression,
  handleClickFPTI
}) => {
  const {
    cardTitle,
    fee,
    cardFooterText,
    cardFooterLinkText,
    feeSideLinkText,
    feeSideSubtitle,
    feeSideTitle,
    feeSubtext,
    feeSideLinkUrl,
    options,
    cardFooterLink,
    feeSideFPTI
  } = componentContent;

  if (!cardTitle || !fee || !feeSubtext || !cardFooterText) {
    fireDetailsPageComponentFailureFpti({
      data: { cardTitle, fee, feeSubtext, cardFooterText },
      componentName: 'DetailsFees',
      fptiImpression
    });
    return null;
  }

  let finalOption = {
    0: {
      cardTitle,
      fee,
      feeSubtext,
      cardFooterText,
      cardFooterLinkText,
      cardFooterLink
    }
  };

  if (options) {
    try {
      finalOption = JSON.parse(options);
    } catch (error) {
      clientLogger.warn(
        `Corrupt JSON in the options object ${options}, Error : ${error}`
      );
    }
  }

  return (
    <section id="details-fees">
      <div className="details-fees-container">
        {feesCard(finalOption, handleClickFPTI)}
        {feeSideTitle &&
          feesSideSection({
            feeSideLinkText,
            feeSideSubtitle,
            feeSideTitle,
            feeSideLinkUrl,
            feeSideFPTI,
            handleClickFPTI
          })}
      </div>
    </section>
  );
};

DetailsFees.propTypes = {
  componentContent: PropTypes.object,
  cardTitle: PropTypes.string,
  cardFooterText: PropTypes.string,
  feeSideLinkText: PropTypes.string,
  feeSideSubtitle: PropTypes.string,
  feeSideTitle: PropTypes.string,
  fptiImpression: PropTypes.func.isRequired,
  feeSubtext: PropTypes.string,
  feeSideLinkUrl: PropTypes.string,
  fee: PropTypes.string,
  featureItem: PropTypes.object,
  handleClickFPTI: PropTypes.func,
  feeSideFPTI: PropTypes.string
};

export default DetailsFees;
